import { useModal } from 'core'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { OKIcon, TextItem, TOUButtons, TOUCancelButton, TOUCheckboxButton, TOUCheckboxLabel, TOUCheckboxWrapper, TOUConfirmButton, TOUTextSection, TOUTitle, TOUWrapper } from './styles'

interface TermsOfUseModal {
    onConfirm: () => {}
    onCancel: () => {}
}

export const TermsOfUseModal: FC<TermsOfUseModal> = ({onConfirm, onCancel}) => {
    const { t } = useTranslation()
    const modal = useModal()
    const [modalChecked, setModalChecked] = useState<boolean>(false)

    const defaultOnCancel = () => modal.hide()

  return (
    <TOUWrapper>
        <TOUTitle>{t("legals.terms_of_use.title")}</TOUTitle>
        <TOUTextSection>
            <TextItem><b>{t("legals.terms_of_use.sections.0")}</b></TextItem>
            <TextItem>{t("legals.terms_of_use.sections.1")}</TextItem>
            <TextItem>{t("legals.terms_of_use.sections.2")}</TextItem>
            <TextItem>{t("legals.terms_of_use.sections.3")}</TextItem>
            <TextItem>{t("legals.terms_of_use.sections.4")}</TextItem>
            <TextItem>{t("legals.terms_of_use.sections.5")}</TextItem>
            <TextItem>{t("legals.terms_of_use.sections.6")}</TextItem>
            <TextItem>{t("legals.terms_of_use.sections.7")} <a href="https://deziiign.ru/legals/license" target="_blank">https://deziiign.ru/legals/license</a>.</TextItem>
            <TextItem><b>{t("legals.terms_of_use.sections.8")}</b></TextItem>
        </TOUTextSection>
        <TOUCheckboxWrapper onClick={() => setModalChecked(p => !p)}>
            <TOUCheckboxButton checked={modalChecked}>
                <OKIcon/>
            </TOUCheckboxButton>
            <TOUCheckboxLabel>{t("legals.terms_of_use.agree.0")} <a href="https://deziiign.com/legals/privacy" target="_blank">{t("legals.terms_of_use.agree.1")}</a></TOUCheckboxLabel>
        </TOUCheckboxWrapper>
        <TOUButtons>
            <TOUCancelButton onClick={!!onCancel ? onCancel : defaultOnCancel}>{t("legals.terms_of_use.cancel")}</TOUCancelButton>
            <TOUConfirmButton disabled={!modalChecked} onClick={onConfirm}>{t("legals.terms_of_use.confirm")}</TOUConfirmButton>
        </TOUButtons>
    </TOUWrapper>
  )
}
import { useModal } from 'core'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { OKIcon, TextItem, TOUButtons, TOUCancelButton, TOUCheckboxButton, TOUCheckboxLabel, TOUCheckboxWrapper, TOUConfirmButton, TOUTextSection, TOUTitle, TOUWrapper } from './styles'

interface TermsOfUseModal {
    onConfirm: () => {}
    onCancel: () => {}
}

export const TermsOfUseModal: FC<TermsOfUseModal> = ({onConfirm, onCancel}) => {
    const { t } = useTranslation()
    const modal = useModal()
    const [modalChecked, setModalChecked] = useState<boolean>(false)

    const defaultOnCancel = () => modal.hide()

  return (
    <TOUWrapper>
        <TOUTitle>{t("legals.terms_of_use.title")}</TOUTitle>
        <TOUTextSection>
            <TextItem><b>{t("legals.terms_of_use.sections.0")}</b></TextItem>
            <TextItem>{t("legals.terms_of_use.sections.1")}</TextItem>
            <TextItem>{t("legals.terms_of_use.sections.2")}</TextItem>
            <TextItem>{t("legals.terms_of_use.sections.3")}</TextItem>
            <TextItem>{t("legals.terms_of_use.sections.4")}</TextItem>
            <TextItem>{t("legals.terms_of_use.sections.5")}</TextItem>
            <TextItem>{t("legals.terms_of_use.sections.6")}</TextItem>
            <TextItem>{t("legals.terms_of_use.sections.7")} <a href="https://deziiign.ru/legals/license" target="_blank">https://deziiign.ru/legals/license</a>.</TextItem>
            <TextItem><b>{t("legals.terms_of_use.sections.8")}</b></TextItem>
        </TOUTextSection>
        <TOUCheckboxWrapper onClick={() => setModalChecked(p => !p)}>
            <TOUCheckboxButton checked={modalChecked}>
                <OKIcon/>
            </TOUCheckboxButton>
            <TOUCheckboxLabel>{t("legals.terms_of_use.agree.0")} <a href="https://deziiign.com/legals/privacy" target="_blank">{t("legals.terms_of_use.agree.1")}</a></TOUCheckboxLabel>
        </TOUCheckboxWrapper>
        <TOUButtons>
            <TOUCancelButton onClick={!!onCancel ? onCancel : defaultOnCancel}>{t("legals.terms_of_use.cancel")}</TOUCancelButton>
            <TOUConfirmButton disabled={!modalChecked} onClick={onConfirm}>{t("legals.terms_of_use.confirm")}</TOUConfirmButton>
        </TOUButtons>
    </TOUWrapper>
  )
}
